/*
 * @Author: wuqinfa
 * @Date: 2024-02-07 16:08:28
 * @LastEditors: wuqinfa
 * @Description: 
 */
import { history, } from 'umi';
import { find, } from 'lodash';

import * as cache from '@/utils/cache';

/**
 * 密码加密
 */
export const encodePwd = (str: string) => {
  let out = '';
  // eslint-disable-next-line no-restricted-syntax
  for (const c of str) {
    out += c.charCodeAt(0) - 23;
  }
  return out;
};

/**
 * replace 到 login 页面
 * @param {*} param
 *    logout    1: 跳转到 login 后，先执行 logout 退出登录操作；  0：  跳转到 login 后，不执行 logout 退出登录操作；
 *              ps: 如果设置 logout = 0，并且当前 token 还没过期的话，会重新再跳回到当前页面，不会停留在 login 页面
 *    isNeedLoginRedirect    true： 默认，附带当前路径，重新登录后回到当前路径；false：反之
 */
export const goToLogin = (param: any = {}) => {
  const { logout = 1, isNeedLoginRedirect = true } = param;

  const { pathname, search } = history.location;
  let query: string = '';

  if (isNeedLoginRedirect && pathname !== '/login') {
    query = `?loginRedirect=${encodeURIComponent(`${pathname}${search}`)}`;
    if (logout) {
      query += `&needLogout=1`;
    }

    history.replace({
      pathname: '/login',
      search: query,
    });
  }
};

/**
 * 获取目标的数据类型
 * @param {*} target
 * @returns
 * const mapTag = '[object Map]';
 * const setTag = '[object Set]';
 * const arrayTag = '[object Array]';
 * const objectTag = '[object Object]';
 * const boolTag = '[object Boolean]';
 * const dateTag = '[object Date]';
 * const errorTag = '[object Error]';
 * const numberTag = '[object Number]';
 * const regexpTag = '[object RegExp]';
 * const stringTag = '[object String]';
 * const symbolTag = '[object Symbol]';
 * 等。。。
 * 详细参考：https://p1-jj.byteimg.com/tos-cn-i-t2oaga2asx/gold-user-assets/2019/9/1/16ce893dc0828b6a~tplv-t2oaga2asx-watermark.awebp
 */
export const getType = (target: any) => {
  return Object.prototype.toString.call(target);
};

/**
 * 从全局字典 dictionary 中获取 dictName 或 itemName
 * @param {*} dictCode
 * @param {*} nameType
 * @param {*} itemValue
 * @returns
 */
export const getDictionaryName = (dictCode: string, nameType: string, itemValue: any) => {
  const dictionary = cache.get('dictionary');
  let result = '';

  if (!dictionary) {
    return;
  }

  const { dictItems = [], dictName = '' } = dictionary[dictCode] || {};

  switch (nameType) {
    case 'dictName':
      result = dictName;
      break;
    case 'itemName':
      const temp = find(dictItems, (item) => {
        return item.itemValue == itemValue; // 不能用全等，后端返回数据有 number 和 string 两种类型
      });

      if (temp) {
        result = temp.itemName || '';
      }

      break;
    default:
      break;
  }

  return result;
};

/**
 * 将file对象（.json文件）转为json对象
 * @param {File | Blob} file file对象
 */
export const fileToJson = (file: File | Blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (res: any) => {
      const { result } = res.target // 得到字符串
      try {
        const data = JSON.parse(result) // 解析成json对象
        resolve(data)
      } catch (error) {
        reject(error);
      }
    } // 成功回调
    reader.onerror = err => {
      reject(err)
    } // 失败回调
    reader.readAsText(new Blob([file]), 'utf-8') // 按照utf-8编码解析
  })
}
